// src/utils/dateUtils.js
export function getNext12Months() {
  const months = [];
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  
  // Get the remaining months of the current year
  for (let i = 0; i < 12; i++) {
    const date = new Date(currentYear, currentMonth + i, 1);
    months.push(date.toISOString().slice(0, 7));
  }
  return months;
}

export function formatEventDates(dateTimes) {
  if (!dateTimes || !Array.isArray(dateTimes) || dateTimes.length === 0) return 'No Date';
  const formattedDates = dateTimes
    .map((dt) => {
      const date = new Date(dt);
      if (isNaN(date.getTime())) return null;
      return `${date.toLocaleString('default', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })} at ${date.toLocaleString('default', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true, // 12-hour AM/PM format for user-facing areas
      })}`;
    })
    .filter((date) => date !== null);
  if (formattedDates.length === 0) return 'No Date';
  if (formattedDates.length === 1) return formattedDates[0];
  if (formattedDates.length === 2) return formattedDates.join(' and ');
  return formattedDates.slice(0, -1).join(', ') + ', and ' + formattedDates[formattedDates.length - 1];
}